export default __webpack_public_path__ + "static/media/withdrawal-delay-bonus-ico.2f027c44.svg";